const camelCase = (str: string) => {
  if (!str) return '';

  return str.replace(/(\w)(\w*)/g, (_g0, g1: string, g2: string) => `${g1.toLowerCase()}${g2}`).replace(/\s/g, '');
};

export default camelCase;
